import type { DropinConfiguration } from './types';

const props: DropinConfiguration = {
    isDropin: true,
    instantPaymentTypes: [],
    paymentMethodComponents: [],
    paymentMethodsConfiguration: {},
    openFirstPaymentMethod: true,
    openFirstStoredPaymentMethod: true,
    showStoredPaymentMethods: true,
    showPaymentMethods: true,
    disableFinalAnimation: false
};

export default props;
